import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass } from "vue"
import _imports_0 from '../../assets/images/SEC_Group - Logo White.png'


const _hoisted_1 = { class: "logo position-absolute start-0 end-0 top-0 bg-black" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "logo-icon"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", { class: "fw-bold ms-10" }, null, -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "border-bottom" }, null, -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("i", { class: "ph-duotone ph-caret-double-right" }, null, -1)
const _hoisted_6 = [
  _hoisted_5
]
const _hoisted_7 = { class: "sidebar-menu" }
const _hoisted_8 = {
  class: "sidebar-navbar-nav ps-0 mb-0 list-unstyled accordion",
  id: "sidebarNavAccordion"
}
const _hoisted_9 = { class: "sidebar-nav-item accordion-item bg-transparent border-0 rounded-0" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("a", {
  href: "#",
  class: "accordion-button rounded-0 shadow-none bg-transparent d-block",
  "data-bs-toggle": "collapse",
  "data-bs-target": "#sidebarCollapseElsa",
  "aria-expanded": "true",
  "aria-controls": "sidebarCollapseElsa"
}, [
  /*#__PURE__*/_createElementVNode("i", { class: "flaticon-more-1" }),
  /*#__PURE__*/_createElementVNode("span", { class: "title" }, "ELSA")
], -1)
const _hoisted_11 = {
  id: "sidebarCollapseElsa",
  class: "accordion-collapse collapse show",
  "data-bs-parent": "#sidebarNavAccordion"
}
const _hoisted_12 = { class: "accordion-body" }
const _hoisted_13 = { class: "sidebar-sub-menu ps-0 mb-0 list-unstyled" }
const _hoisted_14 = { class: "sidebar-sub-menu-item" }
const _hoisted_15 = {
  href: "#",
  class: "accordion-button collapsed rounded-0 shadow-none bg-transparent d-block",
  "data-bs-toggle": "collapse",
  "data-bs-target": "#sidebarCollapseTwentyThree",
  "aria-expanded": "true",
  "aria-controls": "sidebarCollapseTwentyThree"
}
const _hoisted_16 = /*#__PURE__*/_createElementVNode("i", { class: "flaticon-more-1" }, null, -1)
const _hoisted_17 = { class: "title" }
const _hoisted_18 = {
  id: "sidebarCollapseTwentyThree",
  class: "accordion-collapse collapse",
  "data-bs-parent": "#sidebarNavAccordion"
}
const _hoisted_19 = { class: "accordion-body" }
const _hoisted_20 = { class: "sidebar-sub-menu ps-0 mb-0 list-unstyled" }
const _hoisted_21 = { class: "sidebar-nav-item accordion-item bg-transparent border-0 rounded-0" }
const _hoisted_22 = /*#__PURE__*/_createElementVNode("a", {
  href: "#",
  class: "accordion-button rounded-0 shadow-none bg-transparent d-block",
  "data-bs-toggle": "collapse",
  "data-bs-target": "#sidebarCollapseElsa",
  "aria-expanded": "true",
  "aria-controls": "sidebarCollapseElsa"
}, [
  /*#__PURE__*/_createElementVNode("i", { class: "flaticon-more-1" }),
  /*#__PURE__*/_createElementVNode("span", { class: "title" }, "Settings")
], -1)
const _hoisted_23 = {
  id: "sidebarCollapseElsa",
  class: "accordion-collapse collapse show",
  "data-bs-parent": "#sidebarNavAccordion"
}
const _hoisted_24 = { class: "accordion-body" }
const _hoisted_25 = { class: "sidebar-sub-menu ps-0 mb-0 list-unstyled" }
const _hoisted_26 = { class: "sidebar-sub-menu-item" }
const _hoisted_27 = { class: "sidebar-sub-menu-item" }
const _hoisted_28 = { class: "sidebar-sub-menu-item" }
const _hoisted_29 = { class: "sidebar-sub-menu-item" }
const _hoisted_30 = { class: "sidebar-sub-menu-item" }
const _hoisted_31 = { class: "sidebar-nav-item" }
const _hoisted_32 = /*#__PURE__*/_createElementVNode("i", { class: "flaticon-logout" }, null, -1)
const _hoisted_33 = /*#__PURE__*/_createElementVNode("span", { class: "title" }, "Logout", -1)
const _hoisted_34 = [
  _hoisted_32,
  _hoisted_33
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass([
      'sidebar-area position-fixed start-0 top-0 bg-black h-100vh transition',
      { active: _ctx.stateStoreInstance.open },
    ]),
    id: "sidebar-area"
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_router_link, {
        to: "/",
        class: "d-flex align-items-center text-white text-decoration-none"
      }, {
        default: _withCtx(() => [
          _hoisted_2,
          _hoisted_3
        ]),
        _: 1
      }),
      _hoisted_4,
      _createElementVNode("button", {
        class: "sidebar-burger-menu position-absolute lh-1 bg-transparent p-0 border-0",
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.stateStoreInstance.onChange && _ctx.stateStoreInstance.onChange(...args)))
      }, _hoisted_6)
    ]),
    _createElementVNode("div", _hoisted_7, [
      _createElementVNode("ul", _hoisted_8, [
        _createElementVNode("li", _hoisted_9, [
          _hoisted_10,
          _createElementVNode("div", _hoisted_11, [
            _createElementVNode("div", _hoisted_12, [
              _createElementVNode("ul", _hoisted_13, [
                _createElementVNode("li", _hoisted_14, [
                  (_ctx.currentPermissions?.includes('project.read'))
                    ? (_openBlock(), _createBlock(_component_router_link, {
                        key: 0,
                        to: "/projects-list",
                        class: "sidebar-sub-menu-link"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(" Projects ")
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true)
                ])
              ])
            ])
          ])
        ]),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.layoutViews, (layoutView) => {
          return (_openBlock(), _createElementBlock("li", {
            class: "sidebar-nav-item accordion-item bg-transparent border-0 rounded-0",
            key: layoutView.layoutSectionId
          }, [
            _createElementVNode("a", _hoisted_15, [
              _hoisted_16,
              _createElementVNode("span", _hoisted_17, _toDisplayString(layoutView.layoutSectionName), 1)
            ]),
            _createElementVNode("div", _hoisted_18, [
              _createElementVNode("div", _hoisted_19, [
                _createElementVNode("ul", _hoisted_20, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(layoutView.layouts, (layout) => {
                    return (_openBlock(), _createElementBlock("li", {
                      key: layout.layoutId,
                      class: "sidebar-sub-menu-item"
                    }, [
                      (layout.layoutType == 1)
                        ? (_openBlock(), _createBlock(_component_router_link, {
                            key: 0,
                            to: { name: layout.pageName, params: { id: layout.layoutId }  },
                            class: "sidebar-sub-menu-link"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(layout.displayName), 1)
                            ]),
                            _: 2
                          }, 1032, ["to"]))
                        : (_openBlock(), _createBlock(_component_router_link, {
                            key: 1,
                            to: { name: layout.pageName },
                            class: "sidebar-sub-menu-link"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(layout.displayName), 1)
                            ]),
                            _: 2
                          }, 1032, ["to"]))
                    ]))
                  }), 128))
                ])
              ])
            ])
          ]))
        }), 128)),
        _createElementVNode("li", _hoisted_21, [
          _hoisted_22,
          _createElementVNode("div", _hoisted_23, [
            _createElementVNode("div", _hoisted_24, [
              _createElementVNode("ul", _hoisted_25, [
                _createElementVNode("li", _hoisted_26, [
                  (_ctx.currentPermissions?.includes('user.read'))
                    ? (_openBlock(), _createBlock(_component_router_link, {
                        key: 0,
                        to: "/users-list",
                        class: "sidebar-sub-menu-link"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(" Users ")
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("li", _hoisted_27, [
                  (_ctx.currentPermissions?.includes('role.read'))
                    ? (_openBlock(), _createBlock(_component_router_link, {
                        key: 0,
                        to: "/roles",
                        class: "sidebar-sub-menu-link"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(" Roles ")
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("li", _hoisted_28, [
                  _createVNode(_component_router_link, {
                    to: "/embedpages",
                    class: "sidebar-sub-menu-link"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(" Embed Pages ")
                    ]),
                    _: 1
                  })
                ]),
                _createElementVNode("li", _hoisted_29, [
                  (_ctx.currentPermissions?.includes('integration.read'))
                    ? (_openBlock(), _createBlock(_component_router_link, {
                        key: 0,
                        to: "/integrations",
                        class: "sidebar-sub-menu-link"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(" Integrations ")
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("li", _hoisted_30, [
                  (_ctx.currentPermissions?.includes('project.read'))
                    ? (_openBlock(), _createBlock(_component_router_link, {
                        key: 0,
                        to: "/task-types",
                        class: "sidebar-sub-menu-link"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(" Task Type ")
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true)
                ])
              ])
            ])
          ])
        ]),
        _createElementVNode("li", _hoisted_31, [
          _createElementVNode("a", {
            onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.ProcessLogout && _ctx.ProcessLogout(...args))),
            class: "sidebar-nav-link d-block",
            style: {"cursor":"pointer"}
          }, _hoisted_34)
        ])
      ])
    ])
  ], 2))
}